<template>
  <div>
        <van-uploader :multiple="multiple" :oversize='oversize' :after-read="afterRead" v-model="fileList" :max-count="maxCount" @delete="deleteImg" >
          <!-- <img class="pic-img" src="../images/upload.png"  /> -->
        </van-uploader>
  </div>
</template>
<script>
import { Toast } from "vant";
import SHA1 from "sha1"
import axios  from "axios"
export default {
    props:{
        imgList:{
            type:Array,
            default:()=>[]
        },
        multiple:{
            type:Boolean,
            default:true
        },
        maxCount:{
            type:Number,
            default:5
        }

    },
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    oversize(a,b) {
        console.log(a)
        console.log(b)
      Toast("图片最大为10M");
    },
    deleteImg(file,item){
        this.$emit("deleteImg",item)
    },
    // 图片上传
    afterRead(file) {
        let files = [];
        console.log("上传图片");
        console.log(file);
        if (Object.prototype.toString.call(file) == "[object Object]") {
          files.push(file);
          files.map(item=>{
              item.status = 'uploading';
              item.message = '上传中...';
          })
        } else {
          file.map(item => {
              item.status = 'uploading';
              item.message = '上传中...';
            files.push(item);
          });
        }

        let imgList = [];
        for (let i = 0; i < files.length; i++) {
          let fd = new FormData();
          console.log(files);
          fd.append("ShopPic", files[i].file);
          imgList[i] = this.imgUpload(fd);
        }
        Promise.all(imgList).then(res => {

        let list = []
          res.map((item,index) => {
              debugger
              if(item.data.code==1){
                files[index].status = 'succees';
                files[index].message = '上传成功';
                list.push(item)
              }else{
                files[index].status = 'failed';
                files[index].message = item.data.msg;
              }

          });
            this.$emit('upLoadImg',list)
        });
    },
    imgUpload(fd) {
      return new Promise((resolve, reject) => {
        let params = {
          useType: 7,
          update: false,
          timestamp: parseInt(new Date() / 1000),
          nonce: this.guid2()
        };
        var sorted = Object.keys(params)
          .sort()
          .map(item => {
            return item + "=" + params[`${item}`];
          })
          .join("&");
        console.log(sorted);
        var sign = SHA1(sorted);
        console.log(sign);
        var url =
          `${process.env.VUE_APP_HOSPITAL}/api/v3/Shop/UploadShopPic?` +
          sorted +
          "&sign=" +
          sign.toUpperCase();
        console.log(url);
        axios.post(url, fd).then(res => {
          console.log(res);
          Toast.clear();
          if (res.data.code == 1) {
            resolve(res);
          } else {
              resolve(res);
            Toast(res.data.msg);
          }
        });
      });
    },
     guid2() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
  }
};
</script>
<style lang="scss" scoped>
.imgList_img_box{
  position: relative;
}
.imgList_img{
  width: 60px;
  height: 60px;
  margin-right: 5px;
  margin-bottom: 10px;
}
.delete_img{
  position: absolute;
  top: -7px;
  right: -7px;
  z-index: 1;
  width: 14px;
  height: 14px;
  
}
  .imgList {
    margin-top: 12px;
    padding: 10px 13px;
    display: flex;
    flex-wrap: wrap;
  }
</style>